// @ts-nocheck
import ContactForm from 'components/ContactForm';
import Layout from 'components/Layout';
import SEO from 'components/seo';
import HeroSection from 'containers/HeroSection';
import React from 'react';
import { Helmet } from 'react-helmet';
import { SContainer, SDotSVG, SSection } from './styles';

const ContactUs = () => {
  return (
    <Layout navType="dark" navBgColor="#fff" navLinkType="dark">
      <SEO
        title="Contact Us | Get in touch with one of our experts - Oasis Living"
        description="We can answer any questions you may have about letting your property via an online letting agent. Get in touch today and find out how we can help you."
        useTitleTemplate={false}
      />
      <Helmet>
        <link
          rel="stylesheet"
          type="text/css"
          charset="UTF-8"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />
      </Helmet>
      <HeroSection
        // welcomeTitle="Welcome To Oasis Living"
        type="small"
        mainTitle={'Contact Us'}
        subTitle="Whether you are a landlord or tenant, our team are here to help. Use the form below to get in touch and we’ll get back to you as soon as possible."
        backgroundImage={'contact_us/contact_us_hero_bg.jpg'}
      />
      <SSection>
        <SDotSVG right />
        <SContainer>
          <ContactForm formID="contact-us-page-contactform" />
        </SContainer>
      </SSection>
    </Layout>
  );
};

ContactUs.propTypes = {};

export default ContactUs;
